import { IAutomationObject } from '../../types'
import { CounterMedium } from '../CounterMedium';
import { CounterType } from '../CounterType';

export interface IBaseCounter extends IAutomationObject {
    value: number;
    valueDelta: number;
    dimension: string;
    co2Consumption:number;
    actCostsConsumption:number;
    counterType: CounterType;
    counterMedium: CounterMedium;
    //onValueChanged: any;
    currencyCode: string | undefined;

}
export const schema = 'AutomationApps.Devices.Counters.BaseCounter';
export const modelId = 'dtmi:AutomationApps:Devices:Counters:BaseCounter';
